import { render, staticRenderFns } from "./AnnounceManagementScreen.vue?vue&type=template&id=ca71ba9a&scoped=true&"
import script from "./AnnounceManagementScreen.vue?vue&type=script&lang=js&"
export * from "./AnnounceManagementScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca71ba9a",
  null
  
)

export default component.exports